import {css} from "styled-components";

const sizeOptions = {
    xs: css`
        width: min(100% - 20px, 420px) !important;
    `,
    sm: css`
        width: min(100% - 20px, 614px) !important;
    `,
    md: css`
        width: min(100% - 20px, 792px) !important;
    `
}

export const getSizeStyles = ({size}) => sizeOptions[size] ?? sizeOptions['sm']